import React, { createContext, useEffect, useContext } from "react";
import { EventContext, UserContext, firebase } from "context";
import TagManager from "react-gtm-module";

export const AnalyticsContext = createContext();
export const AnalyticsConsumer = AnalyticsContext.Consumer;
export const AnalyticsProvider = ({ children }) => {
  const { event } = useContext(EventContext);
  const { user } = useContext(UserContext);

  const analytics = firebase.analytics();

  useEffect(() => {
    if (event) {
      TagManager.initialize({
        gtmId: process.env.REACT_APP_GTM_ID,
        dataLayer: {
          event: "analytics_init",
          max_params: {
            ...event.tracking,
            debug_mode: event.test,
          },
        },
      });
    }

    if (user) {
      analytics.setUserId(user.uid);
    }
  }, [user, event, analytics]);

  const logClick = ({ label, url }, category) => {
    logEvent({
      eventName: category,
      eventParams: {
        label,
        url,
      },
    });
  };

  const logHeartbeat = ({ duration }) => {
    logEvent({
      eventName: "heartbeat",
      eventParams: {
        duration,
      },
    });
  };

  const logVideoAction = ({ bool, videoLink, videoTitle }) => {
    logEvent({
      eventName: "video",
      eventParams: {
        action: bool ? "open" : "close",
        videoTitle,
        videoLink,
      },
    });
  };

  const logLeadSubmission = ({ formPart, registration }) => {
    logEvent({
      eventName: firebase.analytics.EventName.GENERATE_LEAD,
      eventParams: {
        formPart,
        registration: {
          ...registration,
          user_id: user.uid,
        },
        currency: "USD",
        value: 0,
      },
    });
  };

  const logEvent = ({ eventName, eventParams = {} }) => {
    analytics.logEvent(eventName, {
      ...eventParams,
      max_mcId: event.mastercampaignId,
      max_eventId: event.id,
      max_artist: event.artist,
    });
  };

  const setUserProperties = (data = {}) => {
    analytics.setUserProperties(data);
  };

  return (
    <AnalyticsContext.Provider
      value={{
        logEvent,
        logClick,
        logLeadSubmission,
        logVideoAction,
        logHeartbeat,
        setUserProperties,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
